export const buttonVariants = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERNARY: 'ternary',
  SELECTED: 'selected',
  ROUNDED: 'rounded',
  ROUNDED_NOTIFY_POSITIVE: 'roundedNotifyPositive',
  ROUNDED_NOTIFY_NEGATIVE: 'roundedNotifyNegative',
  ROUNDED_NOTIFY_PENDING: 'roundedNotifyPending',
  TEXT: 'text',
  FULL_ROUNDED: 'fullRounded',
  DISABLED: 'disabled'
};
